export default {
  name: 'manual',
  header: "Descargar Manual de Usuario",
  children: [],
};
